import 'console-polyfill'
import 'custom-event-polyfill'
import './core/Sentry'
// jquery utils
import 'jquery.easing'
import './plugins/nette.ajax'
// nette
import './nette/NetteAutosubmit'
import './nette/NetteValidationMessages'
import './nette/NetteSnippets'
import './nette/NetteEvents'
import './nette/NetteLoading'

import $ from 'jquery'

import { loadComponents } from './core/componentUtils'
import { basePath, isNativeScroll } from './core/config'
import TouchMouseInputResolver from './meta/TouchMouseInputResolver'
import Nette from './nette/NetteForms'
import { runLazyImages } from './services/LazyImages'
import ScrollService, { setScrollPosition } from './services/Scroll'

__webpack_public_path__ = `${basePath}/assets/frontend/js/`

window.Nette = Nette
Nette.initOnLoad()

if ($.nette) {
    $.nette.init()
}

new TouchMouseInputResolver()

if (isNativeScroll()) {
    ScrollService.useNative()
    setScrollPosition()
} else {
    ScrollService.useVirtual()
        .catch(() => ScrollService.useNative())
        .finally(() => setScrollPosition())
}

loadComponents()

runLazyImages()
